import { useMemo, useRef } from 'react'
import { useApp } from '@/core/state/appStore'
import type { UnterschriftDokument } from '../../api/unterschrift'

export function useUnterschriftOeffnen(dokument: UnterschriftDokument) {
  const { state, dispatch, coachings } = useApp()
  const latest = useRef({ coachings, source: state.screen?.source ?? null })
  latest.current = { coachings, source: state.screen?.source ?? null }
  return useMemo(
    () => (id: string, ansehen = false) => {
      const { coachings: cards, source } = latest.current
      dispatch({ type: 'OPEN_PARTICIPANT', screen: {
        kind: 'dokumentUnterschrift',
        dokument,
        participant: { id, name: cards.find((c) => c.id === id)?.name ?? '' },
        source: source ?? undefined,
        ...(ansehen ? { ansehen: true } : {}),
      } })
    },
    [dispatch, dokument],
  )
}
